import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=1d01d82a"
import script from "./TransportForm.vue?vue&type=script&lang=ts"
export * from "./TransportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports